import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import "./AdminEvents.css";

function AdminEvents() {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "events"), (snapshot) => {
      setEvents(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!title || !date || !description) return alert("All fields required");
    await addDoc(collection(db, "events"), {
      title,
      date,
      description,
      createdAt: serverTimestamp(),
    });
    setTitle("");
    setDate("");
    setDescription("");
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "events", id));
  };

  return (
    <div className="admin-events">
      <h2>Manage Events & News</h2>

      <form className="admin-form" onSubmit={handleAdd}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <button type="submit">Add Event</button>
      </form>

      <h3>All Events</h3>
      <ul className="admin-event-list">
        {events.map((ev) => (
          <li key={ev.id}>
            <strong>{ev.title}</strong> <br />
            {ev.date} <br />
            {ev.description} <br />
            <button onClick={() => handleDelete(ev.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AdminEvents;
